import LicensePlates from 'features/licenese-plates/license-plates';

export default LicensePlates;
